import { Pipe, PipeTransform } from '@angular/core';
import { WeekDay } from '../api/contracts/menu';
import { OrderItem } from '../api/contracts/order';
import { WeekIndex } from '../types/menu';
import { getCurrentWeekNumber, getNextWeekNumber } from '../utils/date.utils';
import { MealMenuService } from '../services/meal-menu.service';
import { Observable, map, take } from 'rxjs';

@Pipe({
  name: 'filterOrderItemsByDay',
})
export class FilterOrderItemsByDayPipe implements PipeTransform {
  constructor(private readonly menuService: MealMenuService) {}
  transform(
    orderItems: OrderItem[],
    day: WeekDay,
    weekIndex?: WeekIndex
  ): Observable<OrderItem[]> {
    return this.menuService.weeklyMenus$.pipe(
      take(1),
      map((menus) => {
        if (weekIndex === undefined) {
          return orderItems.filter((item) => item.day === day);
        }
        const weekNumber =
          weekIndex === WeekIndex.THIS_WEEK
            ? getCurrentWeekNumber()
            : getNextWeekNumber();
        const menu = menus?.find((menu) => menu.weekNumber === weekNumber);
        return orderItems.filter(
          (item) => item.day === day && item.weeklyMenuId === menu?.id
        );
      })
    );
  }
}
